<p-table [value]="rowPlaceholders" [paginator]="false">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of columns" [style.width]="getColumnWidth(col)" class="text-left">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr class="bg-hover-gray-100">
            <td *ngFor="let col of columns">
                <div *ngIf="col === 0 && firstColAvatar" class="d-flex align-items-center">
                    <p-skeleton shape="square" width="35px" height="35px"></p-skeleton>
                    <div class="d-flex flex-column ml-3">
                        <p-skeleton width="5rem" height="0.75rem"></p-skeleton>
                        <p-skeleton *ngIf="firstColMultiLine" width="4rem" height="0.5rem" class="mt-1"></p-skeleton>
                    </div>
                </div>
                <div *ngIf="col === 1 && secondColMultiLine" class="d-flex flex-column">
                    <p-skeleton width="5rem" height="0.75rem"></p-skeleton>
                    <p-skeleton width="4rem" height="0.5rem" class="mt-1"></p-skeleton>
                </div>
                <p-skeleton
                    *ngIf="!(col === 0 && firstColAvatar) && !(col === 1 && secondColMultiLine)"
                    width="4rem"
                    height="0.75rem"
                ></p-skeleton>
            </td>
        </tr>
    </ng-template>
</p-table>
